// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"459d9518","769":"78f4498a"}[chunkId] + ".chunk.js";
};